
import koMessages from '../locales/ko-KO';

const KoLang = {
    messages: {
        ...koMessages
    },
    locale: 'ko-KO',
   
};
export default KoLang;